<script>
  import Container from "./Component/Container.svelte";
  import { initClient } from "@urql/svelte";
  import { url } from "./Api/config";

  let path = "/api/user";
  export let registerEventListener = true;

  initClient({
    url: url + path,
  });
</script>

<Container {registerEventListener} />
